/**
 * buttons to show/hide forms
 *
 */

/* internal single */
$("#select_form_single").click(function () {
  $("#select_form_single").addClass("active");
  $("#select_form_group, #select_form_internalGroups").removeClass("active");

  $("#idIndividualForm").show();
  $("#idGroupForm, #idInternalGroupForm").hide();
  $("#idIndividualForm")[0].scrollIntoView({ behavior: "smooth" });
  console.log("show idIndividualForm");
});

/* internal group */
$("#select_form_internalGroups").click(function () {
  $("#select_form_internalGroups").addClass("active");
  $("#select_form_group, #select_form_single").removeClass("active");

  $("#idInternalGroupForm").show();
  $("#idGroupForm, #idIndividualForm").hide();
  $("#idInternalGroupForm")[0].scrollIntoView({ behavior: "smooth" });
  console.log("show idInternalGroupForm");
});

/* external group */
$("#select_form_group").click(function () {
  $("#select_form_group").addClass("active");
  $("#select_form_single, #select_form_internalGroups").removeClass("active");

  $("#idGroupForm").show();
  $("#idIndividualForm, #idInternalGroupForm").hide();
  $("#idGroupForm")[0].scrollIntoView({ behavior: "smooth" });
  console.log("show idGroupForm");
});

/* TESTING: show single form */
try {
  // $("#select_form_single").click();
} catch (error) {
  console.error(error);
}
